import { Aviso } from "./Aviso";

export class Aditivo {
  id: number;

  instituicaoFinanceiraCnpj: string;
  instituicaoFinanceiraSigla: string;

  situacaoId: number;
  situacaoFase: string;
  situacaoNomeInterno: string;
  situacaoNomeExterno: string;
  idPacAditada: number;

  numeroPac: string;
  propostaNumero: string;
  propostaNumeroPesquisa: string;
  propostaAno: string;

  idPacNova: number;
  compradorId: number;
  compradorCnpjCpf: number;
  compradorNome: string;
  compradorCnae: string;
  compradorCnaeNome: string;
  compradorCapitalSocialId: number;
  compradorCapitalSocialNome: string;
  compradorPorteId: number;
  compradorPorteNome: string;
  compradorIndAtividadeDecreto: boolean;
  compradorRobTipo: string;
  compradorRobValor: number;
  compradorRobData: Date;
  grupoCnpjLider: number;
  grupoRobTipo: string;
  grupoRobValor: number;
  grupoRobData: Date;
  municipioInstalId: number;
  municipioInstalNome: string;
  municipioInstalUf: string;
  investimentoCnpj: number;
  investimentoCnae: string;
  investimentoCnaeNome: string;
  datInicioValidade: string;
  datUltimaAtualizacao: string;
  datProtocolo: string;
  datAprovacao: string;
  comentario: string;
  comentarioAnalise: string;
  motivoDevolucao: string;
  ressalvasDeAprovacao: string;
  tipoSolicitacao: string;
  avisosFluxoAprovacao: Aviso[];


  public get grupoRobTipoNome() {
    return this.nomeTipo(this.grupoRobTipo);
  }

  public get compradorRobTipoNome() {
    return this.nomeTipo(this.compradorRobTipo);
  }

  public get descricaoTipoSolicitacao(){
    return this.nomeSolicitacao(this.tipoSolicitacao);
  }

  private nomeSolicitacao(tipoSolicitacao){
    if (tipoSolicitacao == 'A'){
      return 'ADITIVO'
    }else{
      return tipoSolicitacao;
    }
  }

  private nomeTipo(tipo) {
    if (tipo == 'E') {
      return 'Efetivo'
    } else if (tipo == 'P') {
      return 'Previsto'
    } else if (tipo == null) {
      return 'Não Informado'
    } else {
      return tipo;
    }
  }

  public get compradorCnaeIdNome() {
    return (this.compradorCnae) ? this.compradorCnae + ' - ' + this.compradorCnaeNome : null;
  }

  public get investimentoCnaeIdNome() {
    return (this.investimentoCnae) ? this.investimentoCnae + ' - ' + this.investimentoCnaeNome : null;
  }

  public get municipioInstalNomeUf() {
    return (this.municipioInstalId) ? this.municipioInstalNome + '/' + this.municipioInstalUf : null;
  }
}
